import React from 'react';

const BookButton = (props) => {
    return (
        <button className='bg-gradient-to-r from-orange-400 to-yellow-500 hover:from-yellow-500 hover:to-orange-500 px-10 py-3 font-semibold rounded-tr-full rounded-tl-full rounded-bl-full rounded-br-full shadow-xl mt-10'>
            {props.name}
        </button>
    );
};

export default BookButton;